var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSunFilled64(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "64px",
    width: "64px",
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-63 65 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.2,73.8h4.9v18.8h-4.9V73.8z M-1.5,165.3h4.9v18.8h-4.9V165.3z M37.7,125.4h18.8v4.9H37.7V125.4z M-54.1,125.1h18.8v5 h-18.8V125.1z M-47,102l2.4-4.4l16.5,9.2l-2.4,4.3L-47,102z M-27.2,81.8l4.2-2.6l9.9,16l-4.1,2.6L-27.2,81.8z M17.5,161.2l4.3-2.5 l9.4,16.3l-4.3,2.5L17.5,161.2z M31.9,148l2.4-4.3l16.5,9.1l-2.5,4.4L31.9,148z M-24.1,177.7l-4.4-2.4l9.2-16.4l4.3,2.4L-24.1,177.7 z M-46,156.8l-2.6-4.2l16-9.9l2.6,4.1L-46,156.8z M33.7,112.7l-2.5-4.3L47.5,99l2.5,4.3L33.7,112.7z M21.1,98.6l-4.3-2.5l9.1-16.4 l4.3,2.4L21.1,98.6z M-29.3,128.9c0-16.9,13.7-30.6,30.6-30.6s30.5,13.7,30.5,30.6s-13.7,30.6-30.5,30.6 C-15.6,159.5-29.3,145.8-29.3,128.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunFilled64);
export default __webpack_public_path__ + "static/media/sunFilled64.acaffc6bc6e53d7dfbe271c5862a2ce6.svg";
export { ForwardRef as ReactComponent };